// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ManageEvents.module.css */
.ManageEvents_container__nnhdv {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

h1 {
  color: #2c3e50;
  text-align: center;
  margin-bottom: 20px;
}

/* Форма добавления */
.ManageEvents_add_event_form__gf65G {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.ManageEvents_add_event_form__gf65G input,
.ManageEvents_add_event_form__gf65G textarea {
  padding: 10px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
}

.ManageEvents_add_event_form__gf65G textarea {
  resize: vertical;
  min-height: 100px;
}

.ManageEvents_add_event_form__gf65G button {
  padding: 10px 20px;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;
}

.ManageEvents_add_event_form__gf65G button:hover {
  background-color: #219653;
}

/* Таблица событий */
.ManageEvents_events_table__cKHuL {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.ManageEvents_events_table__cKHuL th,
.ManageEvents_events_table__cKHuL td {
  padding: 12px;
  border: 1px solid #e0e0e0;
  text-align: left;
}

.ManageEvents_events_table__cKHuL th {
  background: #f8f9fa;
  font-weight: bold;
}

.ManageEvents_events_table__cKHuL tr:hover {
  background-color: #f8f9fa;
}

/* Кнопки действий */
.ManageEvents_edit_button__ktJrs {
  background: #f1c40f;
  color: white;
  margin-right: 8px;
}

.ManageEvents_delete_button__-raL9 {
  background: #e74c3c;
  color: white;
}

.ManageEvents_edit_button__ktJrs,
.ManageEvents_delete_button__-raL9 {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.ManageEvents_edit_button__ktJrs:hover {
  background: #f39c12;
}

.ManageEvents_delete_button__-raL9:hover {
  background: #c0392b;
}

/* Модальное окно редактирования */
.ManageEvents_modal__iYHXd {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.ManageEvents_modal_content__vtBtT {
  background: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.ManageEvents_modal_content__vtBtT input,
.ManageEvents_modal_content__vtBtT textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
}

.ManageEvents_modal_actions__lKrhb {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.ManageEvents_save_button__j4VR0 {
  background: #27ae60;
  color: white;
}

.ManageEvents_cancel_button__0LI6l {
  background: #e74c3c;
  color: white;
}

.ManageEvents_save_button__j4VR0,
.ManageEvents_cancel_button__0LI6l {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Сообщения */
.ManageEvents_loading__tbUgh {
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  font-size: 18px;
}

.ManageEvents_no_events__Qws-S {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 18px;
}

.ManageEvents_error_message__8yfIn {
  background: #ffe3e3;
  color: #d32f2f;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
  text-align: center;
}

@media (max-width: 768px) {
  .ManageEvents_container__nnhdv {
    padding: 10px;
  }

  .ManageEvents_events_table__cKHuL th,
  .ManageEvents_events_table__cKHuL td {
    padding: 8px;
  }

  .ManageEvents_modal_content__vtBtT {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/Events/ManageEvents.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ManageEvents.module.css */\r\n.container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\nh1 {\r\n  color: #2c3e50;\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Форма добавления */\r\n.add_event_form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.add_event_form input,\r\n.add_event_form textarea {\r\n  padding: 10px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n}\r\n\r\n.add_event_form textarea {\r\n  resize: vertical;\r\n  min-height: 100px;\r\n}\r\n\r\n.add_event_form button {\r\n  padding: 10px 20px;\r\n  background: #27ae60;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.add_event_form button:hover {\r\n  background-color: #219653;\r\n}\r\n\r\n/* Таблица событий */\r\n.events_table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 20px;\r\n}\r\n\r\n.events_table th,\r\n.events_table td {\r\n  padding: 12px;\r\n  border: 1px solid #e0e0e0;\r\n  text-align: left;\r\n}\r\n\r\n.events_table th {\r\n  background: #f8f9fa;\r\n  font-weight: bold;\r\n}\r\n\r\n.events_table tr:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n/* Кнопки действий */\r\n.edit_button {\r\n  background: #f1c40f;\r\n  color: white;\r\n  margin-right: 8px;\r\n}\r\n\r\n.delete_button {\r\n  background: #e74c3c;\r\n  color: white;\r\n}\r\n\r\n.edit_button,\r\n.delete_button {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.edit_button:hover {\r\n  background: #f39c12;\r\n}\r\n\r\n.delete_button:hover {\r\n  background: #c0392b;\r\n}\r\n\r\n/* Модальное окно редактирования */\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal_content {\r\n  background: white;\r\n  padding: 30px;\r\n  border-radius: 8px;\r\n  max-width: 500px;\r\n  width: 100%;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.modal_content input,\r\n.modal_content textarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 8px;\r\n}\r\n\r\n.modal_actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.save_button {\r\n  background: #27ae60;\r\n  color: white;\r\n}\r\n\r\n.cancel_button {\r\n  background: #e74c3c;\r\n  color: white;\r\n}\r\n\r\n.save_button,\r\n.cancel_button {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Сообщения */\r\n.loading {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #7f8c8d;\r\n  font-size: 18px;\r\n}\r\n\r\n.no_events {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #999;\r\n  font-size: 18px;\r\n}\r\n\r\n.error_message {\r\n  background: #ffe3e3;\r\n  color: #d32f2f;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  margin-top: 20px;\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding: 10px;\r\n  }\r\n\r\n  .events_table th,\r\n  .events_table td {\r\n    padding: 8px;\r\n  }\r\n\r\n  .modal_content {\r\n    padding: 20px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ManageEvents_container__nnhdv`,
	"add_event_form": `ManageEvents_add_event_form__gf65G`,
	"events_table": `ManageEvents_events_table__cKHuL`,
	"edit_button": `ManageEvents_edit_button__ktJrs`,
	"delete_button": `ManageEvents_delete_button__-raL9`,
	"modal": `ManageEvents_modal__iYHXd`,
	"modal_content": `ManageEvents_modal_content__vtBtT`,
	"modal_actions": `ManageEvents_modal_actions__lKrhb`,
	"save_button": `ManageEvents_save_button__j4VR0`,
	"cancel_button": `ManageEvents_cancel_button__0LI6l`,
	"loading": `ManageEvents_loading__tbUgh`,
	"no_events": `ManageEvents_no_events__Qws-S`,
	"error_message": `ManageEvents_error_message__8yfIn`
};
export default ___CSS_LOADER_EXPORT___;
